import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SimIconComponent } from '@simOn/ui/sim-icon';

@Component({
  selector: 'lib-filter-counter',
  imports: [SimIconComponent],
  template: ` <div class="counter">
    @if (counter(); as counter) {
      <span>{{ counter }}</span>
    }
    <sim-icon
      [class.pointer]="canClear()"
      icon="close2"
      color="var(--primary-800)"
      [sizeInPx]="16"
      (click)="clear($event)"
    />
  </div>`,
  styles: `
    .counter {
      display: inline-flex;
      align-items: center;
      height: 24px;
      padding: 0 4px;
      border-radius: 64px;
      background-color: var(--ui-primary-lightest, #e0e9f9);
      border: 1px solid var(--primary-default-45, rgba(70, 112, 219, 0.45));
      color: var(--primary-800, #31409c);
      font-size: 14px;
      font-weight: 700;
      line-height: 1.5;
    }

    .counter span {
      padding-left: 4px;
    }

    .pointer {
      cursor: pointer;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterCounterComponent {
  readonly canClear = input<boolean>(false);
  readonly counter = input<number>(0);
  readonly clearEvent = output<void>();

  protected clear(event: MouseEvent) {
    if (!this.canClear()) return;
    event.stopPropagation();
    this.clearEvent.emit();
  }
}
